import request from "@/utils/request"
import {baseURL} from "./baseURL";

export function login(params) {
  return request({
    url: baseURL + '/login',
    method: 'post',
    data: params
  })
}

export function getInfo(params) {
  return request({
    url: baseURL + '/user/get',
    method: 'post',
    data: params
  })
}

export function userSave(params) {
  return request({
    url: baseURL + '/user/save',
    method: 'post',
    data: params
  })
}

export function logOut(params) {
  return request({
    url: baseURL + "/logout",
    method: "post",
    data: params
  })
}

//忘记密码
export function changePassword(params) {
  return request({
    url: baseURL + '/password',
    method: 'post',
    data: params
  })
}

//获取验证码
export function validationCode(params) {
  return request({
    url: baseURL + '/sms',
    method: 'post',
    data: params
  })
}

//注册
export function register(params) {
  return request({
    url: baseURL + '/register',
    method: 'post',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js